import { defineMessages, type MessageDescriptor } from 'react-intl';

/**
 * Messages for **third-party Graph work-item** status values (e.g. GitHub,
 * Asana, Linear).
 *
 * **Scope:** this module is intentionally limited to statuses surfaced through
 * Atlassian Graph third-party work-item connectors. **Jira** issue statuses are
 * deliberately **not** covered here:
 *
 *   - Jira statuses are tenant-configurable (admins can create arbitrary status
 *     names), so they cannot be enumerated as static i18n message keys.
 *   - Jira statuses are already localised server-side and arrive at the client
 *     in the viewer's locale, so re-translating them on the client would be
 *     wrong.
 *
 * The keys of this object are the lower-cased canonical GitHub work-item
 * states (`open`, `closed`), so that `<GraphWorkItemStatusLozenge />` can look
 * up the message directly via
 * `graphWorkItemStatusMessages[status.toLowerCase()]`.
 */
export const graphWorkItemStatusMessages: Record<string, MessageDescriptor> = defineMessages({
	open: {
		id: 'search-page.common.graph-work-item-status.open',
		defaultMessage: 'Open',
		description: 'Graph work item status label for "open" items (e.g. GitHub issues)',
	},
	closed: {
		id: 'search-page.common.graph-work-item-status.closed',
		defaultMessage: 'Closed',
		description: 'Graph work item status label for "closed" items (e.g. GitHub issues)',
	},
});
